var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useRef } from 'react';
import t from 'prop-types';
import useArrastrable from '../../util/use-arrastrable';
import useEscalable from '../../util/use-escalable';
import useStatePosicionEnRango from '../../util/use-state-posicion-en-rango';
import useStateTamEnRango from '../../util/use-state-tam-en-rango';
import { is_touch_device } from '../../util';
var EVENTO_PULSAR = is_touch_device() ? 'onTouchEnd' : 'onMouseUp';

function Mascara(_ref) {
  var _handlersBotonCerrar;

  var id = _ref.id,
      x = _ref.x,
      y = _ref.y,
      w = _ref.w,
      h = _ref.h,
      onMoverPanel = _ref.onMoverPanel,
      onEliminarPanel = _ref.onEliminarPanel;

  var _useStatePosicionEnRa = useStatePosicionEnRango(x, y, -5, 95, -5, 95),
      pos = _useStatePosicionEnRa[0],
      setPos = _useStatePosicionEnRa[1];

  var _useStateTamEnRango = useStateTamEnRango(w, h, 5, 105, 5, 105),
      tam = _useStateTamEnRango[0],
      setTam = _useStateTamEnRango[1];

  var rootRef = useRef(null);

  var _useArrastrable = useArrastrable({
    elementRef: rootRef,
    onArrastrando: function onArrastrando(pos) {
      return setPos(pos);
    },
    onStop: function onStop() {
      return onMoverPanel(id, pos.x, pos.y, tam.w, tam.h);
    }
  }),
      arrastrando = _useArrastrable.arrastrando;

  var tiradorRef = useRef(null);

  var _useEscalable = useEscalable({
    elementRef: rootRef,
    tiradorRef: tiradorRef,
    onEscalando: function onEscalando(tam) {
      return setTam(tam);
    },
    onStop: function onStop() {
      return onMoverPanel(id, pos.x, pos.y, tam.w, tam.h);
    }
  }),
      escalando = _useEscalable.escalando;

  function handleEliminar() {
    onEliminarPanel(id);
  }

  var style = {
    left: pos.x + '%',
    top: pos.y + '%',
    width: tam.w + '%',
    height: tam.h + '%'
  };
  var clases = ['mascara'];

  if (arrastrando || escalando) {
    clases.push('activa');
  }

  var handlersBotonCerrar = (_handlersBotonCerrar = {}, _handlersBotonCerrar[EVENTO_PULSAR] = handleEliminar, _handlersBotonCerrar);
  return React.createElement('div', {
    className: clases.join(' '),
    style: style,
    ref: rootRef
  }, React.createElement('div', _extends({
    className: 'cerrarMascara'
  }, handlersBotonCerrar), 'X'), React.createElement('div', {
    className: 'escalarMascara',
    ref: tiradorRef
  }, React.createElement('div', {
    className: 'flechasEscalado',
    style: {
      pointerEvents: 'none'
    }
  })));
}

Mascara.propTypes = process.env.NODE_ENV !== "production" ? {
  id: t.number.isRequired,
  x: t.number.isRequired,
  y: t.number.isRequired,
  w: t.number.isRequired,
  h: t.number.isRequired,
  onMoverPanel: t.func.isRequired,
  onEliminarPanel: t.func.isRequired
} : {};
export default Mascara;